import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConstants } from "src/app/shared/constants/app.contants";
import { UserService } from "src/app/shared/services/user.service";
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    
    //#region properties
    //#endregion

    //#region ctor
    constructor(
        private _userService: UserService
    ) {}
    //#endregion

    //#region private actions
    //#endregion

    //#region public actions
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes(AppConstants.ACTIONS.AUTHENTICATE) || req.url.toLowerCase().includes('/refreshtoken')) {
          return next.handle(req);
        }

        const token = this._userService.token || localStorage.getItem('QNBNToken');
        return next.handle(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req);
      }
    //#endregion
}
